export default __webpack_public_path__ + "assets/images/d8f821f788641cfc5310d89419d1ff0f.png";